import Chip from './Chip.component';

export default Chip;
